import { api as coreApi, } from '@corti/lib/coreApiService';
import { TranscriptsApiService, } from '@corti/lib/transcriptsApiService';
export const api = {};
export function initTranscriptsApiService(config) {
    api.transcripts = Object.assign(Object.assign({}, new TranscriptsApiService(config)), coreApi.transcripts);
}
